export default __webpack_public_path__ + "static/media/arrow-down.ade11342.svg";